import {
  CardBody
} from 'reactstrap'
import {Link} from 'react-router-dom'
import { truncateString } from '../helper/Text'
import FormatPeriod from '../helper/FormatPeriod'
import { replaceSpecialChar } from '../helper/replaceSpecialChar'

const CardPromo = (post : any) => {
  return (
    <div className="shadow CardPromo">
      <div className="thumbnail">
        <img src={(post.thumbnail !== null) ? post.thumbnail : `${process.env.PUBLIC_URL}/images/image-placeholder.png`} alt={post.title.rendered} className="cover" />
        <div className="merchant-logo">
          {(post.logo) && (
            <img src={post.logo} alt={post.title.rendered} className="img-fluid rounded-circle" />
          )}
        </div>
      </div>
      <CardBody className="d-flex flex-column">
        <Link 
          to={`/promo-year-end/${post.id}/${post.slug}`} 
          onClick={() => {
            window.dataLayer.push({
              'event': 'promotionengagement' ,
              'promotion_name': post.title.rendered,
              'promotion_category': replaceSpecialChar(post.categories_names.toString())
            });
          }}
          dangerouslySetInnerHTML={{__html: truncateString(post.title.rendered, 60)}} href="/" className="mb-auto stretched-link text-decoration-none" 
        />
        <div className="mt-2 d-flex align-items-center end-date text-grey">
          <i className="a-system-icon icon-clock text-grey"></i>
          <span className="ml-2 text-truncate">{(post.start_period !== '') && FormatPeriod(post.start_period, post.end_period, true)}</span>
        </div>
      </CardBody>
    </div>
  )
}

export default CardPromo
